import { render, staticRenderFns } from "./ModuleModal.vue?vue&type=template&id=2e1dbca9&"
import script from "./ModuleModal.vue?vue&type=script&lang=js&"
export * from "./ModuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports